import appEventData from "./appEventData";

const pageLoadCompletedEvent = function () {
  setTimeout(() => {
    appEventData.push({ event: "Page Load Completed" });
  }, 100);
};

export default pageLoadCompletedEvent;
